export default __webpack_public_path__ + "static/media/Img0023.dbf31cea.jpg";